module.exports = __webpack_public_path__ + "fonts/Rubik-500-cyrillic-ext20.d731b50.woff2";